export default "__VITE_ASSET__3fb3a36d__"